import type { PILOT_THIRD_PARTY_SENSORS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/pilot-third-party-sensors-table/pilot-third-party-sensors-table.fr.ts";

export const PILOT_THIRD_PARTY_SENSORS_TABLE_ENGLISH_LOCALE = {
  globalSearchPlaceholder: "Search a value...",
  empty: "No third party sensors found...",
  headers: {
    serialNumber: "Serial number",
    hwId: "Hardware Id",
    csId: "Cs Id",
    neuronId: "Neuron Id",
    siteId: "Site Id",
  },
  filters: {
    placeholders: {
      serialNumber: "Search by serial number...",
      hwId: "Search by hardware Id...",
      csId: "Search by cs Id...",
      neuronId: "Search by neuron Id...",
      siteId: "Search by site Id...",
    },
  },
} satisfies typeof PILOT_THIRD_PARTY_SENSORS_TABLE_FRENCH_LOCALE;
